import Axios from "api/axios"

export const getApplications = async () => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'GET',
      url: '/applications',
    })
    return result.data;
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}
